// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body{background:#fff}#login p{color:#333}#login .ivu-card,#login .ivu-input{color:#333;background:#fff}#login .ivu-card{border-color:#eeeded}", ""]);
// Exports
module.exports = exports;
